import Floatbar from "@app/components/Floatbar";
import { useSetToast } from "@app/components/Toast";
import { Button } from "@design-system/Inputs/Button";
import { FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { ResponseStatus, VisibilityStatus } from "@generated/client/graphql";
import { FC, useState } from "react";
import { useUpdateManyKnowledgeBaseItems } from "../../data";
import { useKnowledgeBasePageTranslations } from "../../i18n";

export const ActionBar: FC<{
    unset: () => void;
    selectedRowIds: string[];
}> = ({ unset, selectedRowIds }) => {
    const { t, keys } = useKnowledgeBasePageTranslations();

    const [activeAction, setActiveAction] = useState<string | undefined>(
        undefined,
    );

    const { updateManyKnowledgeBaseItems } = useUpdateManyKnowledgeBaseItems();
    const { setToastSuccess, setToastError } = useSetToast();

    const handleVisibilityChange = (status: VisibilityStatus) => {
        return () => {
            updateManyKnowledgeBaseItems(
                {
                    ids: selectedRowIds,
                    patch: { aiVisibilityStatus: status },
                },
                {
                    onSettled(data, error) {
                        if (
                            error ||
                            data?.updateManyKnowledgeBaseItems.status !==
                                ResponseStatus.Success
                        ) {
                            return setToastError(
                                t(keys.updateKnowledgeBaseError),
                            );
                        }
                        setActiveAction(undefined);
                        unset();
                        setToastSuccess(t(keys.updateKnowledgeBaseSuccess));
                    },
                },
            );
        };
    };

    return (
        <Floatbar
            unset={unset}
            text={`${selectedRowIds.length} ${t(keys.selected_item, {
                count: selectedRowIds.length,
            })}`}
            open={!!selectedRowIds.length}
            primary={
                <FlexRow gap="2">
                    <Button
                        variant="outlined"
                        size="sm"
                        onClick={handleVisibilityChange(
                            VisibilityStatus.Public,
                        )}
                        className="bg-gradient-to-r from-[#C238CC] to-[#B554F2] text-white border-accent-1-500"
                    >
                        <Button.Icon name="stars" size="sm" />
                        <Text variant="body-sm-bold">
                            {t(keys.action_bar_enable_ai)}
                        </Text>
                    </Button>
                    <Button
                        variant="outlined"
                        size="sm"
                        onClick={handleVisibilityChange(
                            VisibilityStatus.Private,
                        )}
                    >
                        <Button.Icon name="circleCross" size="sm" />
                        <Text variant="body-sm-bold">
                            {t(keys.action_bar_disable_ai)}
                        </Text>
                    </Button>
                </FlexRow>
            }
            activeAction={activeAction}
            setActiveAction={setActiveAction}
        />
    );
};
